import { createAction, props } from '@ngrx/store';
import { DossierNote } from './dossier-notes.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier note',
    props<{dossierId: string}>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier note success', 
    props<{ listData: DossierNote[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier note failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record dossier note',
    props<{dossierId: string, id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record dossier note success', 
    props<{ singleData: DossierNote }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record dossier note failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add record dossier note',
    props<{ dossierId: string, newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record dossier note success'
);
export const addRecordFailure = createAction(
    '[Data] Add record dossier note failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record dossier note',
    props<{ dossierId: string, id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record dossier note success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record dossier note failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record dossier note',
    props<{ dossierId: string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record dossier note success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record dossier note failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier note',
);